var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255 0C114.395 0 0 114.84 0 256s114.395 256 255 256c62.672 0 84.355-29.758 91.703-47.492 10.918-26.363 4.094-59.223-16.598-79.914-14.253-14.254-14.253-37.434 0-51.688 14.235-14.234 38.106-14.285 52.387 0 21.149 21.145 54.406 28.254 80.887 17.285 53.473-22.152 47.09-97.074 47.621-98.691l-.004-.277C508.461 113.21 395.055 0 255 0zm196.902 322.477c-17.183 7.117-37.656-.247-48.195-10.782-25.984-25.988-68.832-25.984-94.812 0-25.98 25.977-25.98 68.133 0 94.114 10.417 10.418 17.234 29.984 10.093 47.218C311.246 471.711 288.523 482 255 482 130.934 482 30 380.617 30 256S130.934 30 255 30c122.324 0 223.68 99.414 226 221.64-.32 1.958 3.547 57.313-29.098 70.837zm0 0",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 226c0 24.813 20.188 45 45 45s45-20.188 45-45-20.188-45-45-45-45 20.188-45 45zm60 0c0 8.27-6.73 15-15 15s-15-6.73-15-15 6.73-15 15-15 15 6.73 15 15zM225 61c-24.813 0-45 20.188-45 45s20.188 45 45 45 45-20.188 45-45-20.188-45-45-45zm0 60c-8.27 0-15-6.73-15-15s6.73-15 15-15 15 6.73 15 15-6.73 15-15 15zM135 241c24.813 0 45-20.188 45-45s-20.188-45-45-45-45 20.188-45 45 20.188 45 45 45zm0-60c8.27 0 15 6.73 15 15s-6.73 15-15 15-15-6.73-15-15 6.73-15 15-15zM135 271c-24.813 0-45 20.188-45 45s20.188 45 45 45 45-20.188 45-45-20.188-45-45-45zm0 60c-8.27 0-15-6.73-15-15s6.73-15 15-15 15 6.73 15 15-6.73 15-15 15zM225 361c-24.813 0-45 20.188-45 45s20.188 45 45 45 45-20.188 45-45-20.188-45-45-45zm0 60c-8.27 0-15-6.73-15-15s6.73-15 15-15 15 6.73 15 15-6.73 15-15 15zm0 0",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorMaster);
export default __webpack_public_path__ + "static/media/color-master.d154109801ad13dd36c97814d114a087.svg";
export { ForwardRef as ReactComponent };